
interface ParseDateOptions {
  dateString: string | Date
  includeHour?: boolean
  includeSeconds?: boolean
  includeTimezone?: boolean
  locale?: 'es-ES' | 'ca-CA' | 'en-GB' | 'fr-FR'
  options?: Intl.DateTimeFormatOptions
}

const isValidDate = (dateString) => !isNaN(Date.parse(dateString))

export function parseDateString({ dateString, locale = 'es-ES', includeHour = false, includeSeconds = false, includeTimezone = false, options = { year: 'numeric', month: 'short', day: 'numeric',} }: ParseDateOptions): string {
  if(!isValidDate(dateString)) {
    console.warn('🗓️ dateString passed is not a valid date pattern and cannot be parsed')
    return ''
  }

  const date = new Date(dateString)

  if (includeHour) {
    options.hour = '2-digit'
    options.minute = '2-digit'
    if(includeSeconds) options.second = '2-digit'
  }

  if (includeTimezone) options.timeZoneName = 'short'

  return date.toLocaleString(locale, options)
}

export function calculateDaysUntilExpiration(now,createdDate) {
  // Calculate the time difference in milliseconds
  const timeDifference = Math.abs(Date.parse(now) - Date.parse(createdDate))

  // Convert milliseconds to days
  const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24))

  return daysDifference
}
